import { motion } from "framer-motion";
import { forwardRef, useEffect, useState } from "react";
import { useProductData } from "../../zustand/productStore.js";
import { useCartData } from "../../zustand/cartStore.js";
import { useReducedProductsPrice } from "../../func/productCardHelpers.js";
import LazyLoad from "react-lazyload";
import ProductSelectorButton from "../ProductSelectorButton.jsx";
import parse from "html-react-parser";

const ProductPackageItemV2 = forwardRef((props, ref) => {
  const productData = useProductData();
  const base = window.post_template;
  const { discountCode } = useCartData();
  const { product, handleChange, active, index } = props;
  const [variantImage, setVariantImage] = useState();
  const withLabel = product.best_seller;
  const bestValue = product.best_value;
  const discountSaveLabel = product.discount_save_label;
  const discountOffLabel = product.discount_off_label;
  const productsContent = window.post_template?.checkout_v4_products;
  const outlineBorder = productsContent.checkout_v4_products_imageWrap;
  const showBulletPoints = base?.checkout_v4_summary.checkout_v4_summary_bullet_points ?? false;

  const productInfo = useReducedProductsPrice(product, productData?.currency_code, productData?.formatted_string);
  const { priceObject, promoPriceObject } = productInfo;

  const productPriceObject =
    productData?.enable_discount_codes && discountCode !== undefined ? promoPriceObject : priceObject;
  const discountPercent =
    productData.enable_discount_codes && discountCode !== undefined
      ? product.promo_discount_amount_percent
      : product.you_save_percentage;

  const fallbackImages = window.post_template.checkout_v4_products.checkout_v4_product_images;
  const matchingImage =
    fallbackImages && fallbackImages.find((obj) => obj.product_amount === product.amount)?.product_image;

  const defaultImage = matchingImage ? matchingImage : product.image.url;
  const image = variantImage ? variantImage : defaultImage;

  return (
    <div
      data-testid="product-container"
      onClick={() => {
        handleChange(index);
      }}
      id={`productCard-${product.amount}`}
      className={
        active
          ? `productPackages_v2__container productPackage_v2__container--visible`
          : `productPackages_v2__container productPackages_v2__container--unchecked`
      }
    >
      <div className="productPacItem_v2__firstBlock">
        {showBulletPoints !== undefined && showBulletPoints !== null && !showBulletPoints && <ProductSelectorButton />}
        <LazyLoad offset={100}>
          <motion.div
            key={image}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{
              delay: 1,
              default: { duration: 0.5 },
            }}
          >
            <img
              className={`productPacItem_v2__image mon-img-85-w mon-img-85-h ${
                outlineBorder ? "productPacItem_v2__image--border" : ""
              }`}
              src={image}
              alt={product.image.alt}
            />
          </motion.div>
        </LazyLoad>
        <div className="productPacItem_v2__label__container">
          {withLabel && <div className="productPacItem_v2__priceBlock__labelTag">{product.status?.toUpperCase()}</div>}
          {bestValue && (
            <div className="productPacItem_v2__priceBlock__bestValueTag">
              {product.tr_best_value_status.toUpperCase()}
            </div>
          )}
          <span data-testid="product-amount" className="productPacItem_v2__label__amount">
            {product.amount}x {product.display_name}
          </span>
          <div data-testid="product-bundle-items" className="productPacItem_v2__label__bundleItems">
            {parse(product.tr_bundle_products)}
          </div>
        </div>
      </div>
      <div className="productPacItem_v2__priceBlock__container">
        <div data-testid="product-price-old" className="productPacItem_v2__priceBlock__oldPrice">
          {productInfo.oldPrice}
        </div>
        <div className="productPacItem_v2__priceBlock__mainPriceBlock">
          <div data-testid="product-price" className="productPacItem_v2__priceBlock__price">
            {productPriceObject?.symbolLeft ? (
              <>
                <sup className="productPacItem_v2__priceBlock__symbol">{productPriceObject?.symbol}</sup>
                {productPriceObject?.number}
                {productPriceObject?.hasCents && `.${productPriceObject?.cents}`}
              </>
            ) : (
              <>
                {productPriceObject?.number}
                {productPriceObject?.hasCents && `.${productPriceObject?.cents}`}
                <sup className="productPacItem_v2__priceBlock__symbol">{productPriceObject?.symbol}</sup>
              </>
            )}
          </div>
          <div className="productPacItem_v2__priceBlock__centsBlock">
            <div
              className={`productPacItem_v2__priceBlock__each
                ${
                  productPriceObject?.hasCents
                    ? `productPacItem_v2__priceBlock__each--with-cents`
                    : `productPacItem_v2__priceBlock__each--without-cents`
                } `}
            >
              {`/`}
              {window.post_template.checkout_v4_products.tr_checkout_v4_products_eachLabel}
            </div>
          </div>
        </div>
        <div className="productPacItem_v2__discountPercent">
          <p>
            {discountSaveLabel} {discountPercent}% {discountOffLabel}
          </p>
        </div>
      </div>
    </div>
  );
});

export { ProductPackageItemV2 };
